<div *ngIf="menuType === 'about-us'">
    <div class="footer-menu-title">关于我们</div>
    <div class="d-flex justify-content-between flex-wrap footer-menu-item">

        <div>
            <a [routerLink]="['/help/about-us']" target="_blank">公司介绍</a>
        </div>
        <div *ngIf="cinema !=2">
            <a [routerLink]="['/help/job-offers']" target="_blank">诚聘英才</a>
        </div>
        <div>
            <a [routerLink]="['/help/terms']" target="_blank">服务条款</a>
        </div>
        <div >
            <a [routerLink]="['/help/faq']" [queryParams]="{cid: 4, item: 63}" target="_blank">充值协议</a>
        </div>
    </div>
</div>

<div *ngIf="menuType === 'web-service'">
    <div class="footer-menu-title">网站服务</div>
    <div class="d-flex justify-content-between flex-wrap footer-menu-item">
        <div>
            <a [routerLink]="['/user']" target="_blank">个人中心</a>
        </div>
        <div>
            <a [routerLink]="['/help']" target="_blank">常见问题</a>
        </div>
        <div>
            <a [routerLink]="['/help/feedback']" target="_blank">在线反馈</a>
        </div>
        <div *ngIf="!allVip">
            <span (click)="showRechargeBox()" style="cursor:pointer">充值中心</span>
        </div>
        <div>
            <a href="/ad-center/intro" target="_blank">广告投放</a>
        </div>
        <div>
            <a [routerLink]="['/help/contact-us']" target="_blank">联系我们</a>
        </div>
    </div>
</div>

<div *ngIf="menuType === 'partner' && partnerList.length > 0" class="partner-ctn">
    <div class="footer-menu-title">合作伙伴</div>
    <div class="d-flex justify-content-start flex-wrap partner-logo-item">
        <div *ngFor="let item of partnerList">
            <a href="{{ item.linkUrl }}" target="_blank">
                <img class="partner-logo" [src]="item.icon">
            </a>
        </div>
    </div>
</div>